import { CardTagsController } from './card-tags.controller'

function cardTags () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      tags: '<'
    },
    templateUrl: '/workflow/directives/card-tags/card-tags-directive.html?$$REVISION$$',
    controller: CardTagsController
  }
}

export { cardTags }
